module.exports = __webpack_public_path__ + "img/ic_home_samsung.0876acc0.png";